export const strings = {
  english: {
    product: 'Product',
    remaining: 'Downloads remaining',
    expires: 'Expires',
    download: 'Download',
  },

  japan: {
    product: '注文商品',
    remaining: '残りのダウンロード',
    expires: '期限',
    download: 'ダウンロード',
  },
};

export const legacyDownloadStrings = {
  english: {
    buttonWin: 'Download WalkMix 1.5.2 for Windows',
    buttonMac: 'Download WalkMix 1.5.2 for MACOS',
    title: 'Legacy Installer (for backward compatibility)',
    description: 'Technical support is not available for this version. Please download and use it at your own discretion.',
  },

  japan: {
    buttonWin: 'WalkMix 1.5.2（Windows版）をダウンロード',
    buttonMac: 'WalkMix 1.5.2（macOS版）をダウンロード',
    title: '旧版インストーラー（後方互換性用）',
    description: 'このバージョンにはテクニカルサポートは提供されません。ご自身の判断でダウンロード・ご利用ください。',
  },
};
